import { Grid } from "@mui/material";
import "react-dropzone-uploader/dist/styles.css";
import {
  getParams,
  navigate,
  sendGetRequest,
  sendPostRequest,
  sendPatchRequest,
  validateEmail,
  validateName,
  validateDomain,
  allowedOperations,
} from "../utils/utils";
import EditPage from "./component/edit-page";
import { useState, useEffect } from "react";
import AppRoutes from "../routing/routes";
import EasyTextEdit from "./component/text-edit";
import {
  FormControlLabel,
  Switch,
  Typography,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";

const _ref = {
  uuid: "",
  name: "",
  numberOfCodes: 20,
  contactName: "",
  contactEmail: "",
  partnershipType: "code",
  serverUrl: "upload.ubongo.org",
  active: true,
};

const PartnersEdit = () => {
  const { uuid } = getParams();
  var [partner, setPartner] = useState(_ref);
  const { canCreate } = allowedOperations();

  const [status, setStatus] = useState({
    error: false,
    loading: false,
    message: null,
  });
  useEffect(() => {
    sendGetRequest(
      `partners?uuid=${uuid}`,
      (loading) => setStatus({ ...{ loading: loading } }),
      (data) => setPartner({ ..._ref, ...data })
    );
    return () => setPartner(_ref);
    // eslint-disable-next-line
  }, [uuid]);

  const createUpdate = () => {
    const numberOfCodes =
      partner.partnershipType === "code" ? partner.numberOfCodes : 0;
    if (!uuid) {
      delete partner.uuid;
      sendPostRequest(
        "partners",
        {
          ...partner,
          active: partner.active != null ? partner.active : true,
          numberOfCodes,
        },
        (loading) => setStatus({ ...{ loading: loading } }),
        (data) => {
          setStatus({
            ...{
              error: data.error,
              message: data.message,
            },
          });
        }
      );
    } else {
      partner.uuid = uuid;
      sendPatchRequest(
        `partners/${uuid}`,
        { ...partner, numberOfCodes },
        (loading) => setStatus({ ...{ loading: loading } }),
        (data) => {
          setStatus({
            ...{
              error: data.error,
              message: data.message,
            },
          });
        }
      );
    }
  };

  const onValueChange = (value, tag) =>
    setPartner({ ...partner, [tag]: value });

  return (
    <EditPage
      title={uuid ? `Edit Partner` : "Add Partner"}
      status={status}
      btnLabel={canCreate ? (uuid ? "Update Now" : "Add Now") : null}
      onSave={() => createUpdate()}
      validated={
        partner.name &&
        validateName(partner.contactName) &&
        partner.numberOfCodes &&
        partner.numberOfCodes > 0 &&
        validateEmail(partner.contactEmail) &&
        validateDomain(partner.serverUrl) &&
        !status.loading
      }
      onBack={() => navigate(`${AppRoutes.users}/${AppRoutes.partners}`, true)}
      onFinish={() => {
        setStatus({ ...{ loading: false, message: null, error: false } });
        if (!status.error) {
          setPartner({ ..._ref });
          navigate(`${AppRoutes.users}/${AppRoutes.partners}`, true);
        }
      }}
    >
      <Grid item md={4} xs={12}>
        <EasyTextEdit
          placeholder="Partner name"
          label="Partner name"
          type="text"
          id="name"
          textField={true}
          errorText=""
          disabled={status.loading}
          value={partner.name}
          onChange={onValueChange}
        />
      </Grid>

      <Grid item md={3} xs={12}>
        <FormControl sx={{ minWidth: 100 }} fullWidth>
          <InputLabel id="partnership">Partnership Type</InputLabel>
          <Select
            value={partner.partnershipType}
            label="Partnership Type"
            labelId="partnership"
            id="partnershipType"
            autoWidth
            onChange={(e) => {
              if (partner.partnershipType !== e.target.value) {
                onValueChange(e.target.value, "partnershipType");
              }
            }}
          >
            {[
              { value: "core", label: "Default App" },
              { value: "content", label: "Data Sharing" },
              { value: "code", label: "Free Trials" },
              { value: "data", label: "Data Sync" },
            ].map((type) => {
              return (
                <MenuItem value={type.value}>
                  &nbsp;&nbsp;&nbsp;{type.label}
                  <br />
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Grid>

      <Grid item md={2} xs={12}>
        <EasyTextEdit
          placeholder="Number of trial codes"
          label="Number of trial codes"
          type="text"
          id="numberOfCodes"
          textField={true}
          errorText=""
          disabled={status.loading || partner.partnershipType !== "code"}
          value={partner.numberOfCodes}
          onChange={onValueChange}
        />
      </Grid>

      <Grid item md={3} xs={12} sx={{ mt: 1 }}>
        <FormControlLabel
          checked={partner.active}
          control={<Switch />}
          onChange={(event) => {
            onValueChange(event.target.checked, "active");
          }}
          label={<Typography variant="body1">Partnership Active</Typography>}
        />
      </Grid>

      <Grid item md={partner.partnershipType === "data" ? 3 : 5} xs={12}>
        <EasyTextEdit
          placeholder="Contact person name"
          label="Contact person name"
          type="text"
          id="contactName"
          textField={true}
          errorText=""
          disabled={status.loading}
          value={partner.contactName}
          onChange={onValueChange}
        />
      </Grid>

      <Grid item md={partner.partnershipType === "data" ? 4 : 7} xs={12}>
        <EasyTextEdit
          placeholder="Contact person email address"
          label="Contact person email address"
          type="text"
          id="contactEmail"
          textField={true}
          errorText=""
          disabled={status.loading}
          value={partner.contactEmail}
          onChange={onValueChange}
        />
      </Grid>

      {partner.partnershipType === "data" && (
        <Grid item md={5} xs={12}>
          <EasyTextEdit
            placeholder="Partner server url"
            label="Partner server url"
            type="text"
            id="serverUrl"
            textField={true}
            errorText=""
            disabled={status.loading}
            value={partner.serverUrl}
            onChange={onValueChange}
          />
        </Grid>
      )}
    </EditPage>
  );
};

export default PartnersEdit;
